import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { getTenantSlug } from '../api/client';
import LandingPage from './LandingPage';
import TenantWelcomePage from './TenantWelcomePage';

/**
 * HomePage - Conditionally renders based on domain context
 * - Main domain: Shows the company landing page
 * - Tenant subdomain (logged in): Redirects to dashboard
 * - Tenant subdomain (not logged in): Shows branded welcome page
 * - ?preview=true: Shows welcome page even when logged in (for admin preview)
 */
const HomePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tenantSlug = getTenantSlug();
  const hasTenantContext = !!tenantSlug;
  const isPreview = searchParams.get('preview') === 'true';

  // Check if user is logged in
  const userInfo = localStorage.getItem('userInfo');
  const isLoggedIn = !!userInfo;

  // On tenant subdomain
  if (hasTenantContext) {
    if (isLoggedIn && !isPreview) {
      // Logged in user on tenant - go to dashboard
      return <Navigate to="/dashboard/calendar" replace />;
    } else {
      // Not logged in or preview mode - show welcome page
      return <TenantWelcomePage />;
    }
  }

  // On main domain - show company landing page
  return <LandingPage />;
};

export default HomePage;
